import React from "react"
import { Link } from "gatsby"

import { HeaderContainer, LogoContainer, NavigationContainer } from "./style"

const NavItems = [
  {
    name: "home",
    link: "/",
  },
  {
    name: "blog",
    link: "/blog",
  },
  {
    name: "about",
    link: "/about",
  },
]

const Header = props => {
  return (
    <HeaderContainer>
      <LogoContainer>
        <Link to="/">
          <h1>Caren Obligar</h1>
          <p>The quick brown fox jumps over the lazy dog.</p>
        </Link>
      </LogoContainer>
      <NavigationContainer>
        {NavItems.map(nav => (
          <li key={nav.name}>
            <Link to={nav.link} rel="noopener nofollow">
              {nav.name}
            </Link>
          </li>
        ))}
      </NavigationContainer>
    </HeaderContainer>
  )
}

export default Header
